import React from 'react';

export const Wrapper = ({
  children,
  condition = true,
  component: Component,
  ...props
}) => {
  // Not putting props.tag inside the component to avoid w3c validation error
  const { tag, ...other } = props;
  return condition ? (
    Component ? (
      <Component {...other}>{children}</Component>
    ) : (
      <CustomTagWrapper {...props}>{children}</CustomTagWrapper>
    )
  ) : (
    children
  );
};

export const CustomTagWrapper = (props) => {
  const { tag, forceOpenToSelf, ...attributes } = props;
  const CustomTag = `${tag || 'div'}`;
  return <CustomTag {...attributes}>{props.children}</CustomTag>;
};
